module.exports = __webpack_public_path__ + "static/media/e.cosentino.be624dbf.svg";